import { Box, Flex, InputGroup, InputLeftAddon, Select, Text, useToast } from "@chakra-ui/react";
import { SpecificSupplierChart } from "./components";
import { showErrorToast, sortAlphabeticallyByAttribute } from "../../../../utils";
import { useState } from "react";
import { useGetSpecificSupplierEmissions, useGetAllSuppliers } from "../../../../hooks/query";
import { hideAppSpinner } from "../../../../context/Store/slices/appSpinnerSlice";
import { useDispatch } from "react-redux";
import { mapSpecificSupplierData } from "../helpers";
import { useTranslation } from "react-i18next";
import * as React from "react";
import { YearSelector } from "../../../../components";

function SpecificSupplierTab({ selectedYear, setSelectedYear }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "suppliersEmissionsDashboard"
  });
  const [suppliers, setSuppliers] = useState([]);
  const [selectedSupplierId, setSelectedSupplierId] = useState(null);
  const dispatch = useDispatch();
  const toast = useToast();

  const {
    isFetching: isFetchingSuppliers
  } = useGetAllSuppliers({
    onSuccess: (data) => {
      if (data && data.length > 0) {
        setSuppliers(data.sort((a, b) => sortAlphabeticallyByAttribute(a, b, "name")));
        setSelectedSupplierId(data[0].id);
      }
    },
    onError: err => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message),
    onSettled: () => dispatch(hideAppSpinner()),
    cacheTime: 0
  });

  const {
    data: specificSupplierData,
    error: specificSupplierError
  } = useGetSpecificSupplierEmissions(selectedSupplierId, selectedYear, {
    enabled: selectedSupplierId !== null,
    onError: err => {
      if (err.response?.status === 404) {
        return;
      }
      showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message)
    },
    onSettled: () => dispatch(hideAppSpinner()),
    cacheTime: 0
  });

  return (
    <Box>
      <Flex gap={4}>
        <YearSelector selectedYear={selectedYear} handleYearSelection={(value) => setSelectedYear(value)} />
        <InputGroup display="flex" alignItems="center" width="400px" marginBlock={4}>
          <InputLeftAddon children={t("supplier")} fontWeight="semibold" />
          <Select
            backgroundColor="white"
            borderRadius="none"
            value={selectedSupplierId}
            onChange={(e) => setSelectedSupplierId(e.target.value)}
          >
            {suppliers.map(el => <option key={el.id} value={el.id}>{el.name}</option>) ?? []}
          </Select>
        </InputGroup>
      </Flex>
      {!isFetchingSuppliers && (!suppliers || suppliers.length === 0 || !selectedSupplierId ||
        (specificSupplierError && specificSupplierError.response.status === 404)) ?
        <Text fontSize="lg" fontWeight="bold">
          {t("noData")}
        </Text> :
        !isFetchingSuppliers && suppliers && suppliers.length > 0 && selectedSupplierId ?
          <SpecificSupplierChart data={mapSpecificSupplierData(specificSupplierData)} /> : null
      }
    </Box>
  );
}

export default SpecificSupplierTab;